import { posPanelConfigurations } from './posPanelConfigurations'

export enum felDocumentType {
  INVOICE = 1,
  INVOICE_WITHOUT_IVA = 2,
  CREDIT_FISCAL = 3,
  EXPORTATION_INVOICE = 11,
  SUJETO_EXC = 14,
  INVOICE_PEQ = 16,
}

export const fiscalTypes: IDictionary<IFelDocumentType> = {
  [felDocumentType.INVOICE]: {
    value: felDocumentType.INVOICE,
    label: 'Factura',
    panelConfig: posPanelConfigurations.payBill,
  },
  [felDocumentType.INVOICE_WITHOUT_IVA]: {
    value: felDocumentType.INVOICE_WITHOUT_IVA,
    label: 'Factura sin IVA',
    panelConfig: posPanelConfigurations.payOrder,
  },
  [felDocumentType.CREDIT_FISCAL]: {
    value: felDocumentType.CREDIT_FISCAL,
    label: 'Crédito fiscal',
    panelConfig: posPanelConfigurations.payReceipt,
  },
  [felDocumentType.EXPORTATION_INVOICE]: {
    value: felDocumentType.EXPORTATION_INVOICE,
    label: 'Factura de exportación',
  },
  [felDocumentType.SUJETO_EXC]: {
    value: felDocumentType.SUJETO_EXC,
    label: 'Factura de sujeto excluido',
    panelConfig: posPanelConfigurations.payExcludedSubject,
  },
}

const felDocumentTypes: IFelDocumentType[] = Object.values(fiscalTypes)

export default felDocumentTypes
